<!--
  Ported from evo-accounts `layout/sidebar/sidebar.component.html`.

  The `.evo-v2` class the original puts on the wrapper is not repeated here:
  evo-accounts mounts its sidebar outside the v2 wrapper and has to opt in, this
  shell puts the whole grid inside one, so a second would only be idempotent.
-->
<div class="sidebar-wrapper">
  <div
    class="sidebar"
    [class.hidden]="state().isHidden"
    role="navigation"
    [attr.aria-label]="'Main navigation'">
    <nav class="sidebar-nav" role="menubar" appMenuKeyboardNav>
      @for (section of menuSections(); track section.id) {
        <div class="menu-section" [class.menu-section--compact]="section.compact" role="none">
          <button
            type="button"
            class="menu-separator"
            [attr.aria-expanded]="!isSectionCollapsed(section.id)"
            [attr.aria-controls]="'menu-section-' + section.id"
            [attr.aria-label]="section.label"
            (click)="toggleSection(section.id)">
            <span>{{ section.label }}</span>
            @if (section.collapsible !== false) {
              <ng-icon
                [name]="isSectionCollapsed(section.id) ? 'lucideChevronRight' : 'lucideChevronDown'"
                class="section-chevron"
                size="14"
                aria-hidden="true" />
            }
          </button>

          @if (!isSectionCollapsed(section.id)) {
            <ul
              class="menu-list"
              [id]="'menu-section-' + section.id"
              role="menu"
              [attr.aria-label]="section.label + ' menu'">
              @for (item of section.items; track item.id) {
                <li class="menu-item" role="none">
                  <app-v2-rail-menu-item
                    [item]="item"
                    (itemClick)="onMenuItemClick(item.id, section.id)" />
                </li>
              }
            </ul>
          }
        </div>
      }
    </nav>
  </div>
</div>
